var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuponactivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4445_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8 4.57043L14 5.77043L7.2 12.5704L6 11.3704L12.8 4.57043ZM2 0.570435H18C19.11 0.570435 20 1.46043 20 2.57043V6.57043C19.4696 6.57043 18.9609 6.78115 18.5858 7.15622C18.2107 7.53129 18 8.04 18 8.57043C18 9.10087 18.2107 9.60958 18.5858 9.98465C18.9609 10.3597 19.4696 10.5704 20 10.5704V14.5704C20 15.6804 19.11 16.5704 18 16.5704H2C1.46957 16.5704 0.960859 16.3597 0.585786 15.9846C0.210714 15.6096 0 15.1009 0 14.5704V10.5704C1.11 10.5704 2 9.68043 2 8.57043C2 8.04 1.78929 7.53129 1.41421 7.15622C1.03914 6.78115 0.530433 6.57043 0 6.57043V2.57043C0 2.04 0.210714 1.53129 0.585786 1.15622C0.960859 0.781148 1.46957 0.570435 2 0.570435ZM2 2.57043V5.11043C2.60768 5.46083 3.11236 5.9651 3.46325 6.57249C3.81415 7.17988 3.9989 7.86897 3.9989 8.57043C3.9989 9.2719 3.81415 9.96099 3.46325 10.5684C3.11236 11.1758 2.60768 11.68 2 12.0304V14.5704H18V12.0304C17.3923 11.68 16.8876 11.1758 16.5367 10.5684C16.1858 9.96099 16.0011 9.2719 16.0011 8.57043C16.0011 7.86897 16.1858 7.17988 16.5367 6.57249C16.8876 5.9651 17.3923 5.46083 18 5.11043V2.57043H2ZM7.5 4.57043C8.33 4.57043 9 5.24043 9 6.07043C9 6.90043 8.33 7.57043 7.5 7.57043C6.67 7.57043 6 6.90043 6 6.07043C6 5.24043 6.67 4.57043 7.5 4.57043ZM12.5 9.57043C13.33 9.57043 14 10.2404 14 11.0704C14 11.9004 13.33 12.5704 12.5 12.5704C11.67 12.5704 11 11.9004 11 11.0704C11 10.2404 11.67 9.57043 12.5 9.57043Z",
    fill: "#121212"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4445_40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuponactivo);
export default __webpack_public_path__ + "static/media/cuponactivo.643893cd922dde99a8c66df13785a888.svg";
export { ForwardRef as ReactComponent };